<template>
  <v-container fluid fill-height style="min-height: calc(100vh - 124px);">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="4" class="align-self-center">
        <v-card outlined rounded="lg">
          <v-card-text>
            <v-row class="black--text">
              <v-col cols="12">
                <h2 class="text-md-h5">
                  Change password
                </h2>
                <p>
                  Please change your password frequently.
                </p>
              </v-col>
              <v-col cols="12">
                <alertsp :alertdata="alertdata"></alertsp>
                <v-form
                  @submit.prevent="submitPassword"
                  ref="formpassword"
                  v-model="formin.valid"
                  lazy-validation>
                  <v-text-field
                    v-model="login.password"
                    :append-icon="formin.password ? 'visibility' : 'visibility_off'"
                    :rules="[rules.required, rules.minpass]"
                    :type="formin.password ? 'text' : 'password'"
                    name="password"
                    label="Old password"
                    hint="At least 8 characters"
                    counter
                    @click:append="formin.password = !formin.password">
                  </v-text-field>
                  <v-text-field
                    v-model="login.newpassword"
                    :append-icon="formin.newpassword ? 'visibility' : 'visibility_off'"
                    :rules="[rules.required, rules.minpass]"
                    :type="formin.newpassword ? 'text' : 'password'"
                    name="newpassword"
                    label="New password"
                    hint="At least 8 characters"
                    counter
                    @click:append="formin.newpassword = !formin.newpassword">
                  </v-text-field>
                  <v-btn
                    type="submit"
                    large
                    block
                    :loading="loading.change"
                    :disabled="loading.change || !formin.valid"
                    :color="maincolor"
                    class="white--text mt-5">
                    Change
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Changepassword',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    login: {
      password: '',
      newpassword: '',
    },
    loading: {
      change: false,
    },
    formin: {
      password: false,
      newpassword: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
    },
    word: 'Vue',
  }),
  created: () => ({
  }),
  mounted() {
    this.$store.commit('UPDATE_TITLE', 'Ganti Password');
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    submitPassword() {
      this.alertdata.show = false;
      if (this.$refs.formpassword.validate()) {
        if (this.tokenscr) {
          this.loading.change = true;
          this.axios
            .post(
              this.api + '/api/user/password',
              qs.stringify(
                this.login,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formpassword.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Password changed successfully!';
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.change = false;
            })
            .catch((error) => {
              this.loading.change = false;
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
